module.exports = __webpack_public_path__ + "static/section-aside-b31f6094acc6d7c4fcd785f7c14f3595.png";